export default "__VITE_ASSET__CaF_aLc2__"